import { NgModule } from '@angular/core';

import { MarcasComponent } from './marcas.component';
import {SharedModule} from "../../shared/shared.module";
import {MarcasRoutingModule} from "./marcas-routing.module";
import {MarcaFormComponent} from "./marca-form/marca-form.component";
import {MarcaListComponent} from "./marca-list/marca-list.component";
import {MarcaApiService} from "./shared/marca-api.service";
import {MarcaNavigationService} from "./shared/marca-navigation.service";
import {MarcasService} from "./shared/marca.service";
import {ModelosModule} from "../modelos/modelos.module";

@NgModule({
  imports: [
    SharedModule,
    ModelosModule,
    MarcasRoutingModule
  ],
  providers: [
    MarcaApiService,
    MarcaNavigationService,
    MarcasService
  ],
  declarations: [
    MarcasComponent,
    MarcaFormComponent,
    MarcaListComponent
  ]
})
export class MarcasModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/marcas/marcas.module.ts
 **/